import React from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <div className="three-fourths columns medium-down--one-whole offset-by-two is-hidden-offset-mobile-only">
      <h1>Cookie Policy</h1>
      <div className="feature-divider" />
      <div className="rte">
        <p><strong>Last updated: September 22, 2026</strong></p>
        <h3>What cookies are</h3>
        <p>Cookies and similar browser storage are small data files used to remember information between page visits.</p>
        <h3>Necessary storage</h3>
        <p>baplehollow uses local browser storage to remember cart contents and keep core shopping features working. Removing it may empty your cart.</p>
        <h3>Preference and measurement cookies</h3>
        <p>If enabled, these may remember site choices or help us understand aggregate page performance. They are not used to build promotional mailing lists.</p>
        <h3>Payment and service providers</h3>
        <p>Payment, security or delivery services opened from checkout may set their own necessary cookies under their respective policies.</p>
        <h3>Your controls</h3>
        <p>You can block or delete cookies and local storage through your browser settings. Blocking necessary storage may prevent the cart or checkout from functioning correctly.</p>
        <h3>Contact</h3>
        <p>Questions about browser storage can be sent to <a href="mailto:model@baplehollow.online">model@baplehollow.online</a>.</p>
      </div>
    </div>
  );
}

export default CookiePolicy;
